import React, { Fragment, useEffect, useState } from "react";
import styles from "../topology.module.scss";
import { Spin, Modal, Form, DatePicker, Button, Tooltip, Row, Col } from "antd";
import { Map, Marker, TileLayer, Popup, Polyline } from "react-leaflet";
import moment from "moment";
import { useLogout } from "Components/Login/quires";
import { useTranslation } from "react-i18next";
import { ImCross } from "react-icons/im";
import { setDeviceRecord, setMapVisible } from "../store/topologySlice";
import { useAppSelector, useAppDispatch } from "store/hook";

import VirtualTable from "./DeviceTableF_TrackerModalF_VirtualTable";
import { useIdleTimer } from "react-idle-timer";
import { TiLocation } from "react-icons/ti";
import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";

import { useDeviceGPS, useGetGPSbyDate } from "../queries";
import { useQueryClient } from "react-query";

import AutoRefresh from "Components/Shared/AutoRefresh";

import ReFresh from "Components/Shared/Refresh";
import Refresh_Simple from "Components/Shared/Refresh_Simple";
import AutoRefresh_Simple from "Components/Shared/AutoRefresh_Simple";

interface ItableData {
  readableTime: any;
  lat: number;
  log: number;
  alt: number;
}

// Overview / Devices Overview  Table 設備欄位中的 info map 彈出 Modal，主要用來顯示該設備的地圖座標

const customMarkerIcon = () =>
  divIcon({
    html: renderToStaticMarkup(<TiLocation style={{ color: "red", fontSize: "2rem", marginRight: "5px" }} />),
    iconAnchor: [18, 24],
  });

const { RangePicker } = DatePicker;

const TrackMap = React.memo(() => {
  const disp = useAppDispatch();
  const { deviceRecord, mapVisible } = useAppSelector((state) => state.topology);
  const { time_zone } = useAppSelector((state) => state.global);
  const [PolylineData, setPolylineData] = useState<[number, number][]>([]);
  const [currentZoom, setCurrentZoom] = useState<number>(17);
  const [form] = Form.useForm();
  const [centerPosition, setCenterPosition] = useState<[number, number]>([0, 0]);
  const [coordinate, setCoordinate] = useState<[any, number, number, number][]>([]);
  const [trackerTableData, setTrackerTableData] = useState<ItableData[]>([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { t } = useTranslation();
  const [SelectedIndex, setSelectedIndex] = useState(undefined);
  const { data: deviceGPS, isLoading: deviceGPSLoading } = useDeviceGPS(deviceRecord?.id, mapVisible);
  const { mutateAsync: getGPSbyDateMutation } = useGetGPSbyDate();

  useEffect(() => {
    if (mapVisible === false) return;
    form.resetFields();
    if (!deviceGPS) {
      return;
    }
    const { coordinateArr, centerPosition, coordinate } = deviceGPS;

    setCenterPosition(centerPosition);
    setCoordinate(coordinate);
    setPolylineData(coordinateArr.map((item) => [item[1], item[2]]));
    setCurrentZoom(16);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapVisible === true, deviceGPS]);

  const SubmitGPSQuery = (values: any) => {
    // setAutoRefresh(false);
    setSelectedIndex(undefined);

    getGPSbyDateMutation({ values, id: deviceRecord.id, time_zone }).then((res) => {
      const { trackerTableData, polylineData, drawerVisible, coordinate, centerPosition } = res;
      setTrackerTableData(trackerTableData);
      if (coordinate) {
        setCoordinate(coordinate);
      }
      if (centerPosition) {
        setCenterPosition(centerPosition);
      }
      setPolylineData(polylineData); //track list的歷史座標
      setDrawerVisible(drawerVisible);
    });
  };

  const disabledDate = (current: any) => {
    return current < moment().subtract(7, "days") || current > moment().add(0, "days");
  };

  const columns = [
    {
      title: (
        <div className={styles.TimeTitle}>
          <span> {t("ISMS.Time")} </span>
          <ImCross
            onClick={() => {
              setDrawerVisible(false);
            }}
            className={styles.cross}
          />
        </div>
      ),
      dataIndex: "readableTime",
      render: (_: any, record: ItableData) => {
        return record["readableTime"];
      },
    },
  ];

  return (
    <Fragment>
      <Modal
        title={
          <Fragment>
            {t("ISMS.Location")}
            <span className={styles.titleDevice}>
              {deviceRecord?.name !== "" ? deviceRecord?.name : deviceRecord?.id}
            </span>
          </Fragment>
        }
        visible={mapVisible}
        onCancel={() => {
          // setCount(0);
          disp(setMapVisible(false));
          disp(setDeviceRecord({ id: undefined }));
          setDrawerVisible(false);
          // setAutoRefresh(false);
          setSelectedIndex(undefined);
          setPolylineData([]);
          setCoordinate([]);
          setCenterPosition([0, 0]);
          form.resetFields();
        }}
        maskClosable={true}
        centered={false}
        footer={null}
        className={`${styles.modal} ${styles.modalmap}`}
      >
        <Row justify="space-between">
          <Col>
            <Form onFinish={SubmitGPSQuery} form={form} style={{ display: "flex" }} layout="vertical">
              <Form.Item name="RangePicker" rules={[{ required: true, message: "required!" }]}>
                <RangePicker disabledDate={disabledDate} format="YYYY-MM-DD" showTime={false} />
              </Form.Item>
              <Form.Item name="DateSubmite" style={{ marginLeft: "3%" }}>
                <Button type="primary" htmlType="submit" loading={deviceGPSLoading}>
                  {t("ISMS.Submit")}
                </Button>
              </Form.Item>
            </Form>
          </Col>
          <Col>
            <div className={styles.IconWrapper}>
              {deviceGPSLoading ? (
                <Spin size="small" />
              ) : (
                <Tooltip title={t("ISMS.Refresh")}>
                  <Refresh_Simple extraFunc={() => setDrawerVisible(false)} queriesArray={["deviceGPS"]} />
                </Tooltip>
              )}

              {deviceGPSLoading ? (
                <Spin size="small" style={{ marginLeft: "10px", paddingRight: "20px" }} />
              ) : (
                <Tooltip title={t("ISMS.AutoRefresh")}>
                  <AutoRefresh_Simple extraFunc={() => setDrawerVisible(false)} queriesArray={["deviceGPS"]} />
                </Tooltip>
              )}
            </div>
          </Col>
        </Row>
        {deviceGPSLoading ? (
          <Spin>
            <Map center={centerPosition} zoom={currentZoom} className={styles.TrackerMap}>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                className="tileMap"
              />
            </Map>
          </Spin>
        ) : (
          <Row gutter={24}>
            {drawerVisible && (
              <Col xs={24} sm={24} md={24} lg={24} xl={4} xxl={4}>
                <VirtualTable
                  columns={columns}
                  dataSource={trackerTableData}
                  scroll={{
                    y: window.innerWidth < 1200 ? 150 : 500,
                    // x: "100vw",
                  }}
                  SelectedIndex={SelectedIndex}
                  setCenterPosition={setCenterPosition}
                  setSelectedIndex={setSelectedIndex}
                  setCurrentZoom={setCurrentZoom}
                  setCoordinate={setCoordinate}
                />
              </Col>
            )}
            <Col xs={24} sm={24} md={24} lg={24} xl={drawerVisible ? 20 : 24} xxl={drawerVisible ? 20 : 24}>
              <Map
                center={coordinate?.[0]?.[0] === "N/A (no GPS data)" ? deviceRecord.lati_longi : centerPosition}
                zoom={currentZoom}
                className={styles.TrackerMap}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  className="tileMap"
                />
                {PolylineData && <Polyline positions={PolylineData} />}

                {/* <CanvasMarkersLayer
                > */}
                {coordinate?.length && (
                  <Marker
                    position={
                      coordinate?.[0]?.[0] === "N/A (no GPS data)"
                        ? deviceRecord.lati_longi
                        : [coordinate[0][1], coordinate[0][2]]
                    }
                    icon={customMarkerIcon()}
                  >
                    <Popup>
                      {t("ISMS.Date")} : {coordinate[0][0]}
                      <br />
                      {t("ISMS.Coordinate")}:{" "}
                      {coordinate?.[0]?.[0] === "N/A (no GPS data)"
                        ? `${deviceRecord.lati_longi[0].toFixed(6)}, ${deviceRecord.lati_longi[1].toFixed(6)}`
                        : `${coordinate[0][1].toFixed(6)}, ${coordinate[0][2].toFixed(6)}`}
                      <br />
                      {t("ISMS.Altitude")}: {coordinate[0][3]}
                      <br />
                      {t("ISMS.Device")}:{" "}
                      {deviceGPS?.nodeInf?.name !== "" ? deviceGPS?.nodeInf?.name : deviceGPS?.nodeInf?.id}
                    </Popup>
                  </Marker>
                )}
                {/* </CanvasMarkersLayer> */}
              </Map>
            </Col>
          </Row>
        )}
      </Modal>
    </Fragment>
  );
});
export default TrackMap;
